"use strict";
var addToUnscopables = require("../internals/add-to-unscopables");
addToUnscopables("flatMap");
